import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuper = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_903_136)",
			children: [/* @__PURE__ */ _jsx("circle", {
				cx: 9.5,
				cy: 8.5,
				r: 7.5,
				fill: "#007DBB"
			}), /* @__PURE__ */ _jsx("circle", {
				cx: 9.5,
				cy: 8.5,
				r: 7,
				stroke: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.755 6.79302L11.0276 6.39664L9.80831 3.92486C9.77501 3.85718 9.72023 3.8024 9.65255 3.7691C9.48283 3.68531 9.27658 3.75513 9.19171 3.92486L7.97247 6.39664L5.24503 6.79302C5.16984 6.80376 5.10109 6.83921 5.04845 6.89292C4.98482 6.95833 4.94975 7.04632 4.95096 7.13757C4.95217 7.22881 4.98955 7.31585 5.0549 7.37955L7.02824 9.30347L6.56202 12.0202C6.55109 12.0834 6.55808 12.1484 6.58221 12.2078C6.60634 12.2672 6.64663 12.3187 6.69852 12.3564C6.75042 12.3941 6.81183 12.4165 6.8758 12.421C6.93978 12.4256 7.00375 12.4121 7.06046 12.3822L9.50001 11.0996L11.9396 12.3822C12.0062 12.4176 12.0835 12.4294 12.1576 12.4166C12.3445 12.3843 12.4702 12.2071 12.438 12.0202L11.9718 9.30347L13.9451 7.37955C13.9988 7.32691 14.0343 7.25816 14.045 7.18296C14.074 6.99497 13.943 6.82095 13.755 6.79302Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_903_136",
			x: 0,
			y: 0,
			width: 19,
			height: 19,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_903_136"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_903_136",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgSuper;
